import { createContext, FunctionComponent, ReactNode, useContext, useMemo } from 'react';

import { ButtonSSTStyleContext } from 'inquiry/context/ButtonSSTStyleContext';
import { serializeBaseStepStyles } from 'inquiry/lib/inquiry';
import { BaseStepStyles, SerializedBaseStepStyles } from 'lib/interfaces/StepsConfig';

export const BaseStepStyleContext =
  createContext<SerializedBaseStepStyles>(serializeBaseStepStyles());

/**
 * For use in pages shared across combined steps, such as Device Handoff.
 * For combined step specific pages, use the combined step's own SST context hook.
 */
export const useBaseStepStyleContext = () => useContext(BaseStepStyleContext);

export const BaseStepStyleProvider: FunctionComponent<{
  children: ReactNode;
  value?: BaseStepStyles | null;
}> = ({ children, value }) => {
  const serializedBaseStyles = useMemo(() => serializeBaseStepStyles(value), [value]);

  return (
    <BaseStepStyleContext.Provider value={serializedBaseStyles}>
      <ButtonSSTStyleContext.Provider value={serializedBaseStyles?.buttons}>
        {children}
      </ButtonSSTStyleContext.Provider>
    </BaseStepStyleContext.Provider>
  );
};
